import React, { useState, useEffect } from 'react';

export default function useDependencyEffect(
  func: () => void,
  dependency: any[]
) {
  const [isFirstRender, setIsFirstRender] = useState(true);
  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    } else {
      func?.();
    }
  }, [...dependency]);

  return isFirstRender;
}
